import React from 'react';
import Tab from '../webcommon/header/tab/Tab';
import { withRouter } from 'react-router';
import styles from './Summary.module.scss';
import tabStyles from './TabOverride.module.scss';
import IndependentAmount from './independentAmount';






export default (withRouter(() => (
    <div className={ styles.summary }>
        <div className={ styles.header }>
            Independent Amount
        </div>
        <div className={ styles.tabContainer }>
            <Tab
                rememberLastTab
                styles={ tabStyles }
                tabs={ [
                    {
                        title: 'Independent Amount',
                        path: '/iaResult',
                        component: IndependentAmount
                    }                ] }
            />
        </div>
    </div>
)));
